import { includes } from 'lodash';

import { SubscriptionPlan, UserPlan } from 'src/models/billing';

export const canCreateProject = (plan: UserPlan) =>
  !includes([SubscriptionPlan.Basic, SubscriptionPlan.Premium], plan);

export const canCreateFolderInProjects = (plan: UserPlan) =>
  !includes([SubscriptionPlan.Basic, SubscriptionPlan.Premium], plan);
